import {
    Box, Avatar, Divider, Drawer, Icon, List,
    ListItemButton, ListItemIcon, ListItemText, useTheme,
    Typography, Collapse
} from "@mui/material"
import Grid from '@mui/material/Grid2';
import { blue, red } from "@mui/material/colors";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAppThemeContext, useAuthContext, useDrawerContext } from "../../contexts";
import { useMatch, useNavigate, useResolvedPath } from "react-router-dom";
import CookieService from "../../services/autenticacao/CookieService";
import { ExpandLess, ExpandMore, StarBorder } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";

interface IListItemLinkProps {
    to: string;
    icon: string;
    label: string;
    style?: any;
    chave?: string;
    key?: string;
    onClick: (() => void) | undefined;
    target?: string;
    href?: string
    }

const ListItemLink: React.FC<IListItemLinkProps> = ({ to, icon, label, onClick, style, chave, key,target, href }) => {

    const navigate = useNavigate();
    const resolvePath = useResolvedPath(to);
    const match = useMatch({ path: resolvePath.pathname, end: false });

    const handleClickOut = () => {
        navigate(to);
        onClick?.();
    }

    let keyChave = UtilidadeService.crypt(chave !== undefined ? chave : label);   
    return (
        <ListItemButton key={`ListItemButton ${keyChave}`}
            onClick={handleClickOut}
            target={target !== null && target !== undefined ? target : "_parent"}
            href={href !== null && href !== undefined ? href : ""}
            selected={!!match}
            sx={style}
            style={{ paddingTop: 3, paddingBottom: 3, fontSize: 14 }}>
            <ListItemIcon key={`ListItemIcon ${keyChave}`} style={{ minWidth: 38 }}>
                <Icon key={`icon${keyChave}`} style={{ fontSize: 20 }}>{icon}</Icon>
            </ListItemIcon>
            <ListItemText key={`ListItemTextPai${keyChave}`} primary={label} />
        </ListItemButton>
    )
}

type Props = {
    children?: React.ReactNode,
};

export const MenuLateral: React.FC<Props> = ({ children }) => {
    const user = CookieService.get("access_user");
    const img = CookieService.get("imagem_Perfil");
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down("md"));
    const { isDrawerOpen, toggleDrawerOpen, drawerOptions } = useDrawerContext();
    const { toggleTheme, themeName } = useAppThemeContext();
    const { isAuthenticated, logout, alterarThema } = useAuthContext();
    const navigate = useNavigate();
    const [imagemPerfil, setImagemPerfil] = useState("");
    const [open, setOpen] = useState(false);
    const [ltsCodigoOpen, setLstCodigoOpen] = useState<number[]>([]);

    const hendleTheme = () => {
        toggleTheme();
        alterarThema(themeName);
    }

    const hendleNomeUsuario = (nome: string, sobrenome: string) => {
        let dados = nome === undefined ? null : nome.split(" ")
        if(dados === null){
            return "";
        }
        return dados.length > 1 ? ` ${dados[0]} ${dados[1]} ${sobrenome} ` : `${dados[0]} ${sobrenome}`;
    }

    const handleClick = (e: number) => {
        setOpen(!open);
        setLstCodigoOpen(ltsCodigoOpen.length > 0 ? ltsCodigoOpen.filter(f => f === e).length > 0 ?
            ltsCodigoOpen.filter(f => f !== e) : [...ltsCodigoOpen, e] : [e]);
    };

    useEffect(() => {
        setImagemPerfil(img === imagemPerfil && imagemPerfil !== undefined ? img : CookieService.get("imagem_Perfil"));
    }, [img])

    let avatar = <Avatar sx={{ height: theme.spacing(12), width: theme.spacing(12), bgcolor: blue[500] }} />;
    if (imagemPerfil != "null") {
        avatar = <Avatar alt="imagem" src={imagemPerfil} sx={{ height: theme.spacing(12), width: theme.spacing(12), bgcolor: blue[500] }} />
    }


    useEffect(() => {
        const token = CookieService.get("access_token");
        if (token === undefined) {
            logout();
            navigate("/login")
        }

    }, []);

    const handleSair = () => {
        logout();
        navigate("/login");
        window.location.reload();
    }

    return (
        <> {isAuthenticated ? <>
            <Drawer open={isDrawerOpen} variant={smDown ? "temporary" : "permanent"} onClose={toggleDrawerOpen}>
                <Box width={theme.spacing(28)} height="100%" display="flex" flexDirection="column" >
                    <Box key={`boxAvatar`} width="100%" height={theme.spacing(20)} display="flex" alignItems="center" justifyContent="center" sx={{ backgroundColor: theme.palette.background.paper }} >
                        {avatar}
                    </Box>
                    <Grid  size={{xs:12, sm:12}} textAlign="center" >
                        <Typography variant="h6">{hendleNomeUsuario(user.nome, user.sobrenome)}</Typography>
                    </Grid>
                    <Divider />
                    <Box key={`boxInt`} flex={1}>
                        {drawerOptions.map((drawerOption, index) => (
                            <List key={`list${index}`} component="nav" sx={{ padding: 0 }}>
                                {drawerOption.visible === true ? (
                                    drawerOption.subMenu.length === 0 ? (
                                        < ListItemLink
                                            icon={drawerOption.icon}
                                            to={drawerOption.path}
                                            chave={index.toString()}
                                            label={drawerOption.label}
                                            href={drawerOption.href}
                                            target={drawerOption.target}
                                            onClick={smDown ? toggleDrawerOpen : undefined}
                                        />
                                    ) :
                                        <>
                                            <ListItemButton tabIndex={index} key={`listItemButtonSub${drawerOption.codigo.toString()}${index}`} onClick={() => handleClick(drawerOption.codigo)}>
                                                <ListItemIcon key={`ligaIcon${drawerOption.codigo.toString()}${index}`} style={{ minWidth: 38 }}>
                                                    <Icon key={`icon${drawerOption.codigo.toString()}`} style={{ fontSize: 20 }}>{drawerOption.icon}</Icon>
                                                </ListItemIcon>
                                                <ListItemText key={`Sub${drawerOption.codigo}${index}`} primary={drawerOption.label} />
                                                {ltsCodigoOpen.length > 0 ? ltsCodigoOpen.filter(f => f === drawerOption.codigo).length > 0 ? <ExpandLess /> : <ExpandMore /> : <ExpandMore />}
                                            </ListItemButton>
                                            {drawerOption.subMenu.map((subMenu, i) => (
                                                <Collapse key={`collapse${subMenu.codigo.toString()}${i}${index}`} in={ltsCodigoOpen.length > 0 ? ltsCodigoOpen.filter(f => f === drawerOption.codigo).length > 0 : open} timeout="auto" unmountOnExit>
                                                    <List key={`List${subMenu.codigo.toString()}${i}`} component="div" disablePadding>
                                                        {subMenu.visible === true && (
                                                            subMenu.subMenu.length === 0 ? (
                                                                <ListItemLink
                                                                    icon={subMenu.icon}
                                                                    to={subMenu.path}
                                                                    chave={`ListItemLinkSub${subMenu.codigo.toString()} `}
                                                                    label={subMenu.label}
                                                                    onClick={smDown ? toggleDrawerOpen : undefined}
                                                                    style={{ pl: 3 }}
                                                                />
                                                            ) :
                                                                <>
                                                                    <ListItemButton tabIndex={i} key={`listItemButtonSub${subMenu.codigo.toString()}${i}`} onClick={() => handleClick(subMenu.codigo)}>
                                                                        <ListItemIcon key={`ligaIcon${subMenu.codigo.toString()}${index}`} style={{ minWidth: 38, paddingLeft: 8 }}>
                                                                            <Icon key={`icon${subMenu.codigo.toString()}`} style={{ fontSize: 20 }}>{subMenu.icon}</Icon>
                                                                        </ListItemIcon>
                                                                        <ListItemText key={`Sub${subMenu.codigo}${index}`} primary={subMenu.label} />
                                                                        {ltsCodigoOpen.length > 0 ? ltsCodigoOpen.filter(f => f === subMenu.codigo).length > 0 ? <ExpandLess /> : <ExpandMore /> : <ExpandMore />}
                                                                    </ListItemButton>
                                                                    {subMenu.subMenu.map((subMenu2, i2) => (
                                                                        <Collapse key={`collapse${subMenu2.codigo.toString()}${i2}${i}`} in={ltsCodigoOpen.length > 0 ? ltsCodigoOpen.filter(f => f === subMenu.codigo).length > 0 : open} timeout="auto" unmountOnExit>
                                                                            <List key={`List${subMenu2.codigo.toString()}${i2}`} component="div" disablePadding>
                                                                                {subMenu2.visible === true && (
                                                                                    subMenu2.subMenu.length === 0 && (
                                                                                        <ListItemLink
                                                                                            icon={subMenu2.icon}
                                                                                            to={subMenu2.path}
                                                                                            chave={`ListItemLinkSub${subMenu2.codigo.toString()} `}
                                                                                            label={subMenu2.label}
                                                                                            onClick={smDown ? toggleDrawerOpen : undefined}
                                                                                            style={{ pl: 5 }}
                                                                                        />
                                                                                    ))}
                                                                            </List>
                                                                        </Collapse>
                                                                    ))}
                                                                </>
                                                        )}

                                                    </List>
                                                </Collapse>
                                            ))}
                                        </>
                                ) : null
                                }
                            </List>
                        ))}


                    </Box>
                    <Box key={`boxExt`}>
                        <ListItemButton tabIndex={98} key="themaButton" onClick={hendleTheme} sx={{display: user.pagamentoConcluido ? "flex" : "none" }}>
                            <ListItemIcon key="themaIcon" style={{ minWidth: 38, }}>
                                <Icon key={`iconExtDarkMode`} style={{ fontSize: 20 }}>dark_mode</Icon>
                            </ListItemIcon>
                            <ListItemText key="thema" primary="Alterar Tema" />
                        </ListItemButton>
                        <ListItemButton tabIndex={99} key="sairButton" onClick={() => { handleSair(); navigate("/login") }}>
                            <ListItemIcon key="sairIcon" style={{ minWidth: 38 }}>
                                <Icon key={`iconExtLogout`} style={{ fontSize: 20 }}>logout</Icon>
                            </ListItemIcon>
                            <ListItemText key="sair" primary="Sair" style={{ fontSize: 30 }} />
                        </ListItemButton>
                    </Box>
                </Box>
            </Drawer>
            <Box height="auto" key="children" marginLeft={smDown ? 0 : theme.spacing(28)}>
                {children}
            </Box>
        </>
            : null
        }
        </>

    );
}